import { useSelector } from "react-redux";
import { useMemo } from "react";
import BifrostLibraryAbi from "../assets/abis/BifrostLibrary.json";
import { useQuery } from "react-query";
import { getContract } from "../utils/contract";

export const BIFROST_LIBRARY = "0xD5945eFe9003349f7A05aF6a66D718dE6F087729";
export const fees = [50, 40, 30, 20];
export const times = [604800, 1209600, 1814400, 2332800];
export const tierFees = {
  ODIN: 10,
  THOR: 8,
  FREYA: 5,
  HEIMDALL: 1,
};


export const useBifrostLibrary = (address) => {
  const web3context = useSelector((state) => state.web3.web3context);
  const ethereum = web3context?.library;

  return [
    ethereum,
    useMemo(
      () => getContract(BifrostLibraryAbi, address, ethereum),
      [ethereum, address]
    ),
  ];
};

export const useGetFee = (
  lastClaimTime,
  tier
) => {
  const [provider, contract] = useBifrostLibrary(BIFROST_LIBRARY);
  const web3context = useSelector((state) => state.web3.web3context);
  const account = web3context?.account;

  async function getFee() {
    try {
      const diff = Date.now() / 1000 - lastClaimTime;
      return contract.methods
        .getCashOutTaxFeeWithLastClaimTime(
          String(Number(diff).toFixed(0)),
          times,
          fees,
          tierFees[tier]
        )
        .call();
    } catch (e) {
      console.log(e);
      return 0;
    }
  }

  return useQuery(
    ["getFee", account, tier, lastClaimTime, tier, Boolean(provider)],
    getFee,
    {
      enabled: Boolean(account && provider),
      cacheTime: 0,
    }
  );
};

export const useGetAvgTax = (nodes, _tier) => {
  const [provider, contract] = useBifrostLibrary(BIFROST_LIBRARY);
  const web3context = useSelector((state) => state.web3.web3context);
  const account = web3context?.account;

  async function getFee(tier, lastClaimTime) {
    try {
      const diff = Date.now() / 1000 - lastClaimTime;
      return contract.methods
        .getCashOutTaxFeeWithLastClaimTime(
          String(Number(diff).toFixed(0)),
          times,
          fees,
          tierFees[tier]
        )
        .call();
    } catch (e) {
      console.log(e);
      return 0;
    }
  }

  function getAvgFeeForTier(nodesLastClaimTime) {
    try {
      return contract.methods
        ._calculateAverageTaxFee (
          nodesLastClaimTime, 
          times, 
          fees, 
          tierFees[_tier])
          .call();
    }catch(e){
      console.log(e);      
    }
    return 0;
  }

  async function getAvgTax() {
    if(_tier){
      let tierNodes = nodes.filter((node) => node.tier === _tier)
      let lastClaimTimeNodes = tierNodes.map((node) => node.lastClaimTime.toString()).join("#")
      return tierNodes.length > 0 ? await getAvgFeeForTier(lastClaimTimeNodes): 0;
    }

    let tierInfo = {
      ODIN: {
        count: 0,
        tax: undefined
      },
      THOR: {
        count: 0,
        tax: undefined
      },
      FREYA: {
        count: 0,
        tax: undefined
      },
      HEIMDALL: {
        count: 0,
        tax: undefined
      },
    };

    for(let idx in nodes){
      let node = nodes[idx]
      tierInfo[node.tier].count += 1
      tierInfo[node.tier].tax = await getFee(node.tier, Number(node.lastClaimTime));
    }

    let totalTax = 0;
    let totalNodes = 0;
    for (let key in tierInfo) {
      totalTax += tierInfo[key].count * Number(tierInfo[key].tax)
      totalNodes += tierInfo[key].count;
    }
    totalTax = totalTax ? totalTax : 1;
    let avgTax = totalNodes>0 ?  totalTax / totalNodes: 0;

    return avgTax;
  }

  return useQuery(
    ["getAvgTax", account, nodes, _tier, Boolean(provider)],
    getAvgTax,
    {
      enabled: Boolean(account && provider),
      cacheTime: 0,
    }
  );
};